var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExternalId = function SvgExternalId(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-eafba7ae-dc17-47c9-a3dd-e57f0b8cf623",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 9",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .uuid-cc260336-fd05-4e31-a78e-c1450a30dcaf{fill:#2e3744;stroke-width:0px;}.uuid-cb61bd4f-1d13-4d54-86aa-9ef2bcfbb953{fill:none;stroke:#fafafa;stroke-linecap:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "uuid-cc260336-fd05-4e31-a78e-c1450a30dcaf",
    x: 0.07,
    y: 0.05,
    width: 11.85,
    height: 8.91,
    rx: 0.86,
    ry: 0.86
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-46ec0141-1695-47ad-ba30-44e50cc42d78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-ddadc23a-3cd5-468d-bcca-b0ce56e79e2d"
  }, /*#__PURE__*/React.createElement("line", {
    className: "uuid-cb61bd4f-1d13-4d54-86aa-9ef2bcfbb953",
    x1: 7.49,
    y1: 3.48,
    x2: 10.34,
    y2: 3.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-cb61bd4f-1d13-4d54-86aa-9ef2bcfbb953",
    x1: 7.49,
    y1: 5.52,
    x2: 10.34,
    y2: 5.52
  })), /*#__PURE__*/React.createElement("g", {
    id: "uuid-73ba81bb-b448-4237-86f3-be90e598c195"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-cb61bd4f-1d13-4d54-86aa-9ef2bcfbb953",
    cx: 3.51,
    cy: 3.59,
    r: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-cb61bd4f-1d13-4d54-86aa-9ef2bcfbb953",
    d: "M1.66,6.51c0-.81.83-1.47,1.85-1.47s1.85.66,1.85,1.47"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExternalId);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "external_id.b7f34324cfd14881372b99e861becee8.svg";